var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM1Sum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.188 59.02V65H22.88v-5.98h33.308zM54.528 11v5.98H22.787V11H54.53zm-8.201 26.515v.908L25.134 65H20v-4.54l18.344-22.507L20 15.57V11h5.134l21.193 26.515z"
  })));
}
export default __webpack_public_path__ + "static/media/M1_Sum.bf3d9c80.svg";
export { SvgM1Sum as ReactComponent };